import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { CtSearchFiltersModule, CtDatatableModule, DeleteConfirmService } from '@ctsolution/ct-framework';
import { AddressBookContactController } from 'src/app/core/controllers/address-book-contact.controller';
import { ListService } from 'src/app/core/lib/list.service';
import { AddressBookService } from '../address-book.service';
import { AddressBookContactComponent } from './address-book-contact.component';
import { AddressBookContactFormModule } from './address-book-contact-form/address-book-contact-form.module';

@NgModule({
  imports: [
    CommonModule,
    CtSearchFiltersModule,
    MatLegacyCardModule,
    CtDatatableModule,
    MatLegacyButtonModule,
    AddressBookContactFormModule
  ],
  declarations: [AddressBookContactComponent],
  exports: [AddressBookContactComponent],
  providers: [AddressBookContactController, ListService, DeleteConfirmService,AddressBookService]
  
})
export class AddressBookContactModule { }
